// extracted by mini-css-extract-plugin
export default {"table-edit-icon":"styles_table-edit-icon__Nzu7c","table-container":"styles_table-container__F9Dpp","users-table":"styles_users-table__ZmaoF"};